import { ComponentNames } from '@space-core/datahub'
import { BaseTrySchema } from '@space-core/datahub/hotmartClub'
import type { DeviceInfoProps } from '@space-core/hooks/useDeviceInfo'

export enum MEMBER_STATUS {
  KEEP = 'KEEP',
  REMOVE = 'REMOVE'
}

export enum CHANGE_TYPE {
  EXCLUSIVA_PARA_ABERTA = 'EXCLUSIVA PARA ABERTA',
  EXCLUSIVA_PARA_PUBLICA = 'EXCLUSIVA PARA PUBLICA',
  PUBLICA_PARA_EXCLUSIVA = 'PUBLICA PARA EXCLUSIVA',
  PUBLICA_PARA_ABERTA = 'PUBLICA PARA ABERTA',
  ABERTA_PARA_EXCLUSIVA = 'ABERTA PARA EXCLUSIVA',
  ABERTA_PARA_PUBLICA = 'ABERTA PARA PUBLICA'
}

export default class TryToChangeCommunityTypeSchema extends BaseTrySchema {
  action: string
  communityId: number
  communityType: string
  role: string
  removeUsersOption: string
  changeType: string
  deviceInfo: DeviceInfoProps

  constructor({
    communityId = 0,
    communityType,
    result,
    statusCode,
    failureDescription,
    userRole,
    removeUsersOption,
    changeType,
    deviceInfo
  }) {
    super({
      result: result,
      statusCode: statusCode,
      componentName: ComponentNames.CHANGE_COMMUNITY_TYPE_MODAL,
      componentSource: ComponentNames.CONFIGURATION_MODAL,
      failureDescription: failureDescription
    })
    this.communityId = communityId
    this.communityType = communityType
    this.role = userRole
    this.removeUsersOption = removeUsersOption
    this.changeType = changeType
    this.action = 'try_to_change_community_type'
    this.deviceInfo = deviceInfo
  }

  getDataHubEventData() {
    return {
      ...super.prepare(),
      hasAccessToTheCommunity: true,
      communityId: this.communityId,
      communityType: this.communityType,
      changeType: this.changeType,
      memberStatus: this.removeUsersOption ? MEMBER_STATUS.REMOVE : MEMBER_STATUS.KEEP,
      ...this.deviceInfo
    }
  }
}
